/* eslint-disable no-console */
export class UndefinedStrategy {
  onSuccess(boxNumber, citiboxId, deliveryId) {
    console.warn('SDK not loaded: called success with: ', boxNumber, citiboxId, deliveryId);
  }

  onError(errorCode) {
    console.warn('SDK not loaded: called error with: ', errorCode);
  }

  onFail(failureCode) {
    console.warn('SDK not loaded: called fail with: ', failureCode);
  }

  onCancel(cancelCode) {
    console.warn('SDK not loaded: called cancel with: ', cancelCode);
  }

  openBLE(url, mac, ssid, serviceUUID, scommandUUID, sreplyUUID, openToken, otaServiceUUID, otaControlUUID, otaDataUUID) {
    console.warn(
      'SDK not loaded: called openBLE with: ',
      mac,
      ssid,
      url,
      serviceUUID,
      scommandUUID,
      sreplyUUID,
      openToken,
      otaServiceUUID,
      otaControlUUID,
      otaDataUUID
    );

    if (window.CitiboxCourierWebApp.robot) {
      window.CitiboxCourierWebApp.robot.playOpenLock();
    }
  }

  cancelOpenBLE() {
    console.warn('SDK not loaded: called cancelOpenBLE');
  }

  blePermissionsStatus() {
    console.warn('SDK not loaded: called blePermissionsStatus');
  }

  characteristicsSDK() {
    console.warn('SDK not loaded: called characteristicsSDK');
  }

  sdkInfo() {
    console.warn('SDK not loaded: called sdkInfo');
  }

  onSessionToken(sessionToken) {
    console.warn('SDK not loaded: called onSessionToken', sessionToken);
  }
}
